import { Vue, Component } from "vue-property-decorator";
import CS from './parts/CS.vue'
import faq from './parts/content';
import {FaqItem, Chapters, Question} from './index.d';
import user_module from '@/modules/user/index';

@Component({
    components:{
        CS
    }
})

export default class FAQ extends Vue {
    faq: {[key: string] : FaqItem[]} = faq;
    activeChapter: string = 'video';
    activeQuestions: string[] = ['1', '2'];
    
    get id(){

        return String(this.$route.query?.id) || '';
    }

    get currentSites(){

        return user_module.currentSites;
    }

    get productData(): any{

        return this.currentSites.find(product => product.id === this.id) || {};
    }

    get productName(){
        return this.productData.name;
    }

    get currentFaq(){

        if (this.id){
            const currentFaq = this.faq[this.id];
            if (currentFaq){
                return currentFaq;
            }
        }

        return []

    }

    get chapters(): Chapters{


        return this.currentFaq
        .filter((item: FaqItem) => !item.cs && !item.videos)
        .map((item: FaqItem) => ({
            title: item.chapter,
            id: item.id, 
            active: item.id === this.activeChapter
        }));


    }

    
    get baseinfo(): Chapters{


        return this.currentFaq
        .filter((item: FaqItem) => item.cs || item.videos)
        .map((item: FaqItem) => ({
            title: item.chapter,
            id: item.id, 
            active: item.id === this.activeChapter
        }));


    }

    get questions(): Question[]{
        
        const chapterItem: FaqItem | undefined = this.currentFaq.find((item: FaqItem) => item.id === this.activeChapter);

        if (chapterItem && chapterItem.questions){

            return chapterItem.questions.map((question: Question) => 
                ({...question, active: Boolean(this.activeQuestions.find((item: string) => question.id === item))}
            ))

        }

        return []
    }
    

    get videos(): any{
        
        const chapterItem: FaqItem | undefined = this.currentFaq.find((item: FaqItem) => item.id === this.activeChapter);

        if (chapterItem && chapterItem.videos){
            return chapterItem.videos;
        }

        return ''
    }

    get csid(): string{

        const chapterItem: FaqItem | undefined = this.currentFaq.find((item: FaqItem) => item.id === this.activeChapter);

        if (chapterItem && chapterItem.cs){
            return chapterItem.cs;
        }

        return ''
    }

    changeChapter(id: string){

        this.activeChapter = id;
        this.activeQuestions = [];
    }

    toggle(id: string){

        console.log('id', id, this.activeQuestions);
        const idx = this.activeQuestions.findIndex((q: any) => q === id);

        if (idx !== -1){

            this.activeQuestions.splice(idx, 1);
            console.log('splice?');
        } else {
            console.log('push?');
            this.activeQuestions.push(id);
        }
        
        
    }
}